var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"statusModule":"healthCheck","resource":"loadbalancer_health_checks","base-info":_vm.baseInfo,"auto-hidden-columns-key":"health_check_hidden_columns"}})
}
var staticRenderFns = []

export { render, staticRenderFns }